/**
 * Removes a link by id search.
 *
 * @param {Correlation} correlation
 * @param {string} id
 */
export function removeLink(correlation, id) {
    correlation.link = correlation.link.filter((_link) => _link.id !== id);
    return correlation;
}
//# sourceMappingURL=removeLink.js.map